import { createSlice } from '@reduxjs/toolkit'

export const tagSlice = createSlice({
    name: 'tags',
    initialState: {
        tags: [],
        tagsToDelete: [],
        tagsToMerge: [],
        deleteTags: false,
        mergeTags: false,
        mergeTagNewName: null, // the name given to tags that get merged.
    },
    reducers: {
        setTags(state, action) {
            //state.tags = action.payload;
            state.tags = action.payload.slice().sort((a, b) =>
                a.name.localeCompare(b.name)
            );
        },
        addTag(state, action) {
            const newTag = action.payload
            const existingIdx = state.tags.findIndex(t => t.id === newTag?.id)

            // check if tag is already in tags array
            // and only update fields on the tag that
            // have changed.
            if(existingIdx > -1){
                state.tags[existingIdx] = {
                    ...state.tags[existingIdx],
                    ...newTag
                }
            } else {
                state.tags.push(action.payload)
            }
        },
        setTagsToDelete(state, action) {
            state.tagsToDelete = [...action.payload]
        },
        setTagsToMerge(state, action) {
            state.tagsToMerge = [...action.payload]
        },
        updateDeleteTags(state, action){
            state.deleteTags = !!action.payload // make sure this is always a boolean
        },
        updateMergeTags(state, action){
            state.mergeTags = !!action.payload // make sure this is always a boolean
        },
        updateMergeTagNewName(state, action){
            state.mergeTagNewName = action.payload
        },
        removeTag(state, action){
            const { id } = action.payload

            state.tags = state.tags.filter(t => t.id !== id)
        }
    },
})

export const { setTags, addTag, setTagsToDelete, setTagsToMerge, updateDeleteTags, updateMergeTags, updateMergeTagNewName, removeTag } = tagSlice.actions;

export default tagSlice.reducer;